import React from "react";
import s from "./index.module.scss";
import HeroContent from "@/components/Common/Hero/_HeroContent";
import { PrismicNextImage } from "@prismicio/next";
import Head from "next/head";

const Slide = ({ data, index }) => {
  const {
    background_image,
    background_image_mobile,
    background_image_tab,
    side_image,
    hero_title,
    hero_description,
    view_more_link,
  } = data;

  return (
    <div>
      <Head>
        <link
          rel="preload"
          as="image"
          href={data.background_image?.url}
          imageSrcSet={`
            ${data.background_image?.url}&w=1440 1440w,
            ${data.background_image_tab?.url}&w=1000 1000w,
            ${data.background_image_mobile?.url} 768w
          `}
          media="(max-width:1024px)"
        />
      </Head>
      <div className={s.slide}>
        {index === 0 ? (
          <div className={s.heroContainer}>
            <PrismicNextImage
              field={data.background_image}
              fallbackAlt=""
              className={`${s.heroImage} ${s.desktop}`}
              loading="eager"
              priority
              imgixParams={{ auto: "compress,format" }}
            />

            <PrismicNextImage
              field={data.background_image_tab}
              fallbackAlt=""
              className={`${s.heroImage} ${s.tablet}`}
              loading="eager"
              priority
              imgixParams={{ auto: "compress,format" }}
            />

            <PrismicNextImage
              field={data.background_image_mobile}
              fallbackAlt=""
              className={`${s.heroImage} ${s.mobile}`}
              loading="eager"
              width={768}
              height={900}
              priority
              sizes="(max-width: 768px) 100vw, 33vw"
            />
          </div>
        ) : (
          <div className={s.heroContainer}>
            <PrismicNextImage
              field={data.background_image}
              fallbackAlt=""
              className={`${s.heroImage} ${s.desktop}`}
              sizes="(min-width: 1440px) 100vw, 33vw"
              loading="lazy"
            />

            <PrismicNextImage
              field={data.background_image_tab}
              fallbackAlt=""
              className={`${s.heroImage} ${s.tablet}`}
              sizes="(min-width: 768px) 100vw, 33vw"
              loading="lazy"
            />

            <PrismicNextImage
              field={data.background_image_mobile}
              fallbackAlt=""
              className={`${s.heroImage} ${s.mobile}`}
              width={768}
              height={900}
              sizes="(max-width: 768px) 100vw, 33vw"
              loading="lazy"
            />
          </div>
        )}

        <div className={s.hero_content_wrapper}>
          <div>
            <HeroContent
              viewMoreLink={view_more_link}
              title={hero_title}
              description={hero_description}
              homepage={true}
              visibility={true}
              page={"Homepage"}
              sideImage={side_image?.url || ""}
              normalHeading={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slide;
